import { Box, LoadingIndicator } from 'roo-ui/components';

const ProcessingIndicator = ({ ...props }) => (
  <Box {...props}>
    <LoadingIndicator />
  </Box>
);

ProcessingIndicator.propTypes = {
  ...Box.propTypes,
};

export default ProcessingIndicator;
